<template>
  <component v-if="css || desktop" :is="tag || 'div'" class="desktop-only">
    <slot />
  </component>
</template>

<script setup lang="ts">
defineProps<{
  tag?: string;
  css?: boolean;
}>();

const { desktop } = useBreakpoints();
</script>

<style scoped>
@media (max-width: 850px) {
  .desktop-only {
    display: none;
  }
}
</style>